<template>
  <v-app :id="time">
    <div style="text-align: center; padding-left: 30% !important" width="100%">
      <v-alert
        v-if="responseStatus.alertStatus"
        :type="responseStatus.type"
        width="40%"
        style="z-index: 9999; text-align: left"
        dense
        dismissible
        @input="closeDialog"
      >
        {{ responseStatus.text }}
      </v-alert>
    </div>
    <v-card app style="margin-top: 30px">
      <v-card-title>{{ name }}</v-card-title>

      <v-card-text>
        <div>
          <v-list-item style="text-align: left">
            <v-list-item-content>
              <v-list-item-title v-html="trackingInfo.shipping_name"></v-list-item-title>
              <v-list-item-subtitle
                v-html="'Address: ' + trackingInfo.shipping_address"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-html="'จังหวัด : ' + trackingInfo.shipping_province"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-html="'รหัสไปรษณีย์. : ' + trackingInfo.shipping_postcode"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-html="'เบอร์โทรศัพท์ : ' + trackingInfo.shipping_phone"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    label="ชื่อบริษัทขนส่ง"
                    hide-details="auto"
                    type="text"
                    v-model="editedItem.company"
                  ></v-text-field>
                  <div class="v-messages theme--dark">
                    <div class="v-messages__wrapper"></div>
                  </div>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    label="หมายเลขอ้างอิง"
                    hide-details="auto"
                    type="text"
                    v-model="editedItem.tracking_code"
                  ></v-text-field>
                  <div class="v-messages theme--dark">
                    <div class="v-messages__wrapper"></div>
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <v-menu
                    ref="tracking_date"
                    v-model="tracking_date"
                    :close-on-content-click="false"
                    :return-value.sync="editedItem.tracking_date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.tracking_date"
                        label="วันที่จัดส่ง"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required="required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editedItem.tracking_date"
                      no-title
                      scrollable
                      :min="nowDate"
                    >
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="tracking_date = false">
                        ยกเลิก</v-btn
                      >
                      <v-btn
                        color="success"
                        @click="$refs.tracking_date.save(editedItem.tracking_date)"
                      >
                        ตกลง
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="info darken-1" @click="close">ปิด</v-btn>
        <v-btn class="success darken-2" @click="save" :disabled="isValid">
          <v-icon>mdi-content-save-outline</v-icon> บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-app>
</template>

<script>
//import _ from "underscore";
import moment from "moment";
import axios from "axios";

export default {
  name: "TrackingCode",
  props: {
    trackingInfo: {
      type: Object,
    },

    trackingType: {
      type: String,
    },
    saleInfo: {
      type: Object,
    },
  },
  data: () => ({
    name: "ข้อมูลการจัดส่ง",
    time: "",
    //valid:false,
    nowDate: moment(moment()).add(-30, "days").toISOString().slice(0, 10),
    tracking_date: "",
    //saleInfo:null,
    lists: [],
    isEdit: false,
    //editedItem: {},
    responseStatus: {
      alertStatus: false,
      text: "",
    },
    api_uri: process.env.VUE_APP_LOYALTY_API_URI,
    closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
    custId: sessionStorage.getItem("custId"),
    dialogDelete: false,
    totalItems: 0,
    //isValid:false,
  }),
  created() {
    this.time = Math.round(Math.random() * 1000).toString();
  },
  mounted() {
    console.log(this.trackingInfo);
    console.log(this.saleInfo);
    /*
    console.log('TrackingCode');
    console.log(this.trackingType);
    console.log(this.$store.state.sales);
    console.log(this.trackingItem);
    console.log('-------------------------------------------');
    console.log(this.trackingItem);
    if(this.trackingItem.tracking_infomation !== undefined){
    
      this.editedItem = this.trackingItem.tracking_infomation;
    }else{
      this.editedItem = {company:"",tracking_code:"",tracking_date:""};
    }
    */
    //this.saleInfo = this.$store.state.sales;
  },
  computed: {
    editedItem() {
      //console.log(this.$store.state.sales);
      if (this.$store.state.sales.tracking_information === undefined) {
        return {};
      } else {
        return this.$store.state.sales.tracking_information;
      }
    },

    isValid: {
      cache: false,
      get() {
        console.log("isValid");
        console.log(this.editedItem);

        if (
          this.editedItem.company === undefined ||
          this.editedItem.tracking_code === undefined ||
          this.editedItem.tracking_date === undefined
        ) {
          return true;
        } else {
          return false;
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit("closeTracking");
    },

    async save() {
      console.log("save");
      console.log(this.editedItem);

      if (this.editedItem.company !== undefined) {
        const payload = {
          _id: this.trackingInfo._id,
          //custId: this.custId,
          tracking_information: {
            company: this.editedItem.company,
            tracking_code: this.editedItem.tracking_code,
            tracking_date: this.editedItem.tracking_date,
          },
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),

          //updatedBy: sessionStorage.getItem("email"),

          //status: this.editedItem.status,
        };
        let uri = "";
        if (this.trackingType == "Order") {
          uri = "/v1/tracking/order";
        } else {
          uri = "/v1/tracking/redeem";
        }

        try {
          //
          await axios
            .post(
              this.api_uri + uri,
              payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              console.log(response);
              if (response.data.data._id) {
                //this.editedItem = response.data;
                // console.log(this.$store.state.sales);
                // console.log(this.$store.state.salesList);
                // console.log(this.$store.state.salesList.indexOf(this.$store.state.sales));
                let index = this.$store.state.salesList.indexOf(this.$store.state.sales);
                this.$store.state.salesList[index] = response.data.data;

                //console.log(this.$store.state.salesList[index]);
                this.$emit("updateSales");
              }
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
            });
        } catch (err) {
          this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          };
        }
      } else {
        this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: "ข้อมูลไม่ครบถ้วน",
          alertStatus: true,
        };
      }
      //// console.log("$emit (Update)");
      //this.$emit("updateTrackingCodeStatus", this.responseStatus);
      // this.resetInput();
    },

    // timeout close overlay

    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
        this.$emit("closeTracking");
      }, sec);
    },

    closeDialog() {
      this.responseStatus.alertStatus = false;
      this.$emit("closeTracking");
    },
  },
  watch: {
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          //alert(this.responseStatus.alertStatus);
          this.closeInTime(this.closeInSec);
          //this.responseStatus.alertStatus = false;
        }
      },
    },
  },
};
</script>
